import React from 'react';
import { useHistory } from 'react-router-dom';

import AppBar from 'components/AppBar';
// import { Desktop, Mobile } from 'components/Responsive';

import { Container, Content, Title, Subtitle } from './styles';

type Props = {
  children?: React.ReactNode;
  title: string;
  subtitle?: string;
  backPath?: string;
  withFloatingButton?: boolean;
};

const BasicLayout = ({ children, title, subtitle, backPath, withFloatingButton = false }: Props) => {
  const history = useHistory();

  return (
    <Container>
      <AppBar goBack={backPath ? () => history.push(backPath) : history.goBack}>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </AppBar>
      <Content withFloatingButton={withFloatingButton}>{children}</Content>
    </Container>
  );
};

export default BasicLayout;
